import { render } from "./SvgPolygonDraw.vue?vue&type=template&id=1b63e514"
import script from "./SvgPolygonDraw.vue?vue&type=script&lang=js"
export * from "./SvgPolygonDraw.vue?vue&type=script&lang=js"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__